import Vue from "vue";
import { playRewardedAd } from "js/crossword/sdk/playRewardedAd";
import { Provider, RevealType } from "js/crossword/types";
import { trackRevealAd } from "js/tracking/track";
import OS from "framework/utils/OS";
import PopupButtons from "./PopupButtons";
import PopupContainer from "./PopupContainer";

import commonStyles from "../css/common.module.css";
import styles from "../css/RevealPuzzleAdPopup.module.css";

export default Vue.extend({
  inject: [Provider.LOCALIZATION],
  methods: {
    watchAd() {
      playRewardedAd().then(() => {
        trackRevealAd(RevealType.Puzzle);
        this.$emit("reveal", RevealType.Puzzle);
        this.$emit("close");
      });
    },
  },
  render() {
    return (
      <PopupContainer customClasses={[styles.reveal]}>
        <div class={styles.contentWrapper}>
          <div><img class={[styles.icon, styles.iconReveal]} src="images/Bulb_Icon.svg" /></div>

          <div class={commonStyles.lineBreakEnabled} style="margin-bottom: 0.1em">
            {this.localization.get("Are you sure you want to")}
            {!OS.desktop ? "\n" : " "}
            <b>{this.localization.get("reveal the whole puzzle?")}</b>
          </div>

          <div style="margin-bottom: 1.3em;">
            {this.localization.get("Watch an ad and reveal it.")}
          </div>
        </div>

        <PopupButtons buttons={[{
          label: this.localization.get("Back"),
          onClick: () => this.$emit("close"),
          reversed: true,
        }, {
          label: this.localization.get("Reveal"),
          onClick: this.watchAd,
        }]} />
      </PopupContainer>
    );
  }
});